var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-padding-bottom-10px"},[_c('a-spin',{attrs:{"spinning":_vm.loading}},[_c('div',{ref:"sexTypeChart",staticStyle:{"height":"220px"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }